import {useLatestFieldDefinitionAnalysisRun} from '../../../../hooks/api/fieldDefinitionAnalysisRun';
import {ObjectId} from 'bson';

export function useIsAnalysisRunInProgress({
  fieldDefinitionId,
}: {
  fieldDefinitionId: ObjectId;
}) {
  const {data: analysisRun} = useLatestFieldDefinitionAnalysisRun({
    fieldDefinitionId,
  });

  return analysisRun?.results.some((result) => result.status === 'running');
}
